<script lang="ts" setup>
import ThreadList, {
  ThreadListInstance,
} from "@/components/mobile/ThreadList.vue";
import { useGlobalUser } from "@/stores/globalUser";
import { useMoment } from "@/stores/moment";
import { onActivated, onBeforeMount, onMounted, ref, UnwrapRef } from "vue";

import ThreadsNav from "@/components/mobile/ThreadsNav.vue";
import MomentActions from "@/components/mobile/popup/MomentActions.vue";
import SearchPopup from "@/components/mobile/popup/SearchPopup.vue";

import { useI18n } from "vue-i18n";

import ThreadItemSkeleton from "@/components/mobile/moment/ThreadItemSkeleton.vue";
import { useRouter } from "vue-router";
const momentStore = useMoment();
const globalUser = useGlobalUser();
const { t } = useI18n();
// 状态
const newMomentListRef = ref<ThreadListInstance | null>(null);
const followingMomentListRef = ref<ThreadListInstance | null>(null);
const showSearchPopup = ref<boolean>(false);
const router = useRouter();

const switchToPublicIfNotLogin = () => {
  if (momentStore.tabIdx !== 0) {
    momentStore.tabIdx = 0;
  }
};

// Lifecycle
const initData = async () => {
  momentStore.initMomentListIfEmpty();
};
onBeforeMount(() => {
  switchToPublicIfNotLogin();
  initData();
});

onActivated(() => {
  switchToPublicIfNotLogin();
});

const onDbClick = () => {
  followingMomentListRef.value!.scrollToTop();
};

// popup
const showActions = ref(false);
const toOperateMoment = ref<Moment | null>(null);
const onActionClick = (moment: UnwrapRef<Moment>) => {
  toOperateMoment.value = moment;
  showActions.value = true;
};
onActivated(() => {
  switchToPublicIfNotLogin();
});

onMounted(() => switchToPublicIfNotLogin());
</script>
<template>
  <div class="h-full grid overflow-hidden grid-rows-[auto_1fr] lg:pt-4">
    <!-- 顶部导航 -->
    <threads-nav @on-double-click="onDbClick" :show-center="false" show-back>
      <template v-if="globalUser.isLogin" #right>
        <button
          class="btn btn-primary btn-sm rounded"
          @click="
            router.push({
              name: 'createThread',
            })
          "
        >
          {{ $t(`Buttons.createThread`) }}
        </button>
      </template>
    </threads-nav>
    <!-- moment -->
    <div class="w-full overflow-hidden relative">
      <VanTabs
        key="threadListPage"
        v-model:active="momentStore.tabIdx"
        class="h-full thread-tabs grid grid-rows-[auto_1fr] moment-tab moment-tab1"
        swipeable
      >
        <VanTab :title="t(`Community.myOCMoments`)">
          <thread-list
            ref="newMomentListRef"
            :on-pull-load="() => momentStore.initMomentListIfEmpty(true)"
            :on-scroll-load="() => momentStore.fetchMomentList(true)"
            class="px-2 suggestedMoment"
            :need-login="true"
          >
            <div
              v-if="false && momentStore.newMomentList.length === 0"
              class="w-full flex flex-col gap-2"
            >
              <ThreadItemSkeleton class="p-2 border-b" />
            </div>
            <div v-else>
              <thread-item1
                v-for="moment in momentStore.newMomentList"
                :key="moment.uuid"
                :moment="moment"
                enable-audio-play
                enable-show-more-link
                showReplyList
                showCoinVote
                @reaction-click="onActionClick"
                enable-wish
              />
            </div>
          </thread-list>
        </VanTab>
      </VanTabs>
    </div>
    <moment-actions v-model:show="showActions" :moment="toOperateMoment" />
    <SearchPopup v-if="false" v-model:show="showSearchPopup"></SearchPopup>

    <!-- 发动态的按钮 -->
  </div>
</template>
<style>
.thread-tabs .van-tabs__line {
  width: 3rem;
}

.sub-tab {
  --van-tabs-nav-background: hsl(var(--n));
}

.moment-tab1 .van-tabs__wrap {
  display: none;
}
</style>
